export default __webpack_public_path__ + "static/media/assassin_icon.7410ae68.png";